import React from 'react'
import _ from 'lodash'
import { L2TabularListItemSummary } from '../l2/L2TabularListItem'
import { L2TabularListContent, L2TabularListHeader, L2TabularListRoot } from '../l2/L2TabularList'
import { DrugDisposal } from '@fusion-advantage/formlib'

interface L3DrugDisposalListProps {
	models?: DrugDisposal[]
}

const L3DrugDisposalList = ({models = []}: L3DrugDisposalListProps) => {
	const items = _.map(models, (model, modelIdx) => {
		return (
			<L2TabularListItemSummary key={modelIdx}>
				<div>
					<div>{model.Name}</div>
					<div>{model.NameAdditional}</div>
				</div>
				<div>{model.Address}</div>
				<div>{model.Distance_MI ? model.Distance_MI.toFixed(1) + ' mi' : null}</div>
			</L2TabularListItemSummary>
		)
	})
	return (
		<L2TabularListRoot columnCount={3}>
			<L2TabularListHeader>
				<div>Name</div>
				<div>Address</div>
				<div>Distance</div>
			</L2TabularListHeader>
			<L2TabularListContent>
				{items}
			</L2TabularListContent>
		</L2TabularListRoot>
	)
}

export default L3DrugDisposalList
